export default __webpack_public_path__ + "static/media/buildingnetworks.fc01401e.png";